export default __webpack_public_path__ + "static/flag-pt-a03c57b5dc625d872c9547fa439e82f3.svg";